import { TourCategoryModel } from 'api-hooks/tour-category';
import * as Yup from 'yup';

export const TourCategoryFormSchema = () =>
  Yup.object({
    name: Yup.string().default('').required(),
    description: Yup.string().default(''),
    adminCommission: Yup.number().default(0),
    operatorCommission: Yup.number().default(0),
    salesCommission: Yup.number().default(0),
  });

export type TourCategoryFormType = Yup.InferType<
  ReturnType<typeof TourCategoryFormSchema>
> & { tourCategory?: TourCategoryModel };
